export default class AuthSessionAccessError extends Error {
    constructor(message = '') {
        super(message);
    }
}
